import { isCurrentCultureRightToLeft } from 'owa-localize';
import { trace } from 'owa-trace';

import type { SonoraFile } from 'owa-editor-sonora-types';

/**
 * For cloudy attachments, we are parsing a sharepoint or onedrive URL.
 */
const getBreadcrumbedFilePath = (suggestion: SonoraFile): string => {
    let breadcrumbedFileOrEmailPath: string = '';

    // To parse URL for cloudy attachment, create temporary anchor tag.
    const tempAnchorTag: HTMLAnchorElement = document.createElement('a');
    tempAnchorTag.href = suggestion.url;

    try {
        // Hostname should be something like sharepoint.microsoft.com
        // Pathname should be something like /documents/file.docx
        // Splitting the pathname using / as the delimiter, we can ignore the first and last tokens,
        // as the file path does not include the name of the file itself.
        breadcrumbedFileOrEmailPath = decodeURIComponent(tempAnchorTag.hostname);
        const isRTL: boolean = isCurrentCultureRightToLeft();

        const pathTokens: string[] = decodeURIComponent(tempAnchorTag.pathname).split('/');
        for (let i = 1; i < pathTokens.length - 1; i++) {
            if (isRTL) {
                // RTL
                breadcrumbedFileOrEmailPath = pathTokens[i] + ' < ' + breadcrumbedFileOrEmailPath;
            } else {
                // LTR
                breadcrumbedFileOrEmailPath += ' > ' + pathTokens[i];
            }
        }
    } catch (e) {
        trace.info(
            `[SonoraResultsUtils] Failed to get breadcrumbed file path.
            hostname: ${tempAnchorTag.hostname}, pathname: ${tempAnchorTag.pathname},
            error message: ${e.message}`
        );
    } finally {
        return breadcrumbedFileOrEmailPath;
    }
};

export default getBreadcrumbedFilePath;
